/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type PoliciesRetrieveRequest = {} | null | undefined;
export type PoliciesRetrieveResponse = any;

export type PoliciesRetrieveQuery = {};

/**
 * GET /dmx-server/policies/
 *
 * ```yaml
 * operationId: policies_retrieve
 * description: |-
 *   Filtrovani dle targets
 *   Např. - http://localhost:8000/dmx-server/policies/?targets=frontend
 *   Lze filtrova i pres vice hodnot
 *   Např. - http://localhost:8000/dmx-server/policies/?targets=gql&targets=rest
 * tags:
 *   - policies
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const policiesRetrieveOperation = (rest?: PoliciesRetrieveQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/policies/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/policies/' };
  };

/**
 * GET /dmx-server/policies/
 *
 * ```yaml
 * operationId: policies_retrieve
 * description: |-
 *   Filtrovani dle targets
 *   Např. - http://localhost:8000/dmx-server/policies/?targets=frontend
 *   Lze filtrova i pres vice hodnot
 *   Např. - http://localhost:8000/dmx-server/policies/?targets=gql&targets=rest
 * tags:
 *   - policies
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const policiesRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: PoliciesRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = policiesRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/policies/
 */
export const usePoliciesRetrieveResource = (
  query: PoliciesRetrieveQuery | null,
  useCached?: boolean,
): UseResource<PoliciesRetrieveResponse> => {
  return useResource<PoliciesRetrieveResponse>({
    path: query === null ? null : policiesRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
